var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIllustrationsFunnelTrafficInstagramAds(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "keli8zopic",
    cx: "43.628%",
    cy: "84.837%",
    r: "41.808%",
    fx: "43.628%",
    fy: "84.837%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#FEDA75"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "46.731%",
    stopColor: "#FDC25E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "72.457%",
    stopColor: "#FCA13F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#FA7E1E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "846rmjzuab",
    x1: "14.879%",
    x2: "80.227%",
    y1: "15.592%",
    y2: "89.345%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#4F5BD5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "50.276%",
    stopColor: "#962FBF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#D62976"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "ado0rxvh3d",
    width: "189.4%",
    height: "189.4%",
    x: "-44.7%",
    y: "-44.7%",
    filterUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "SourceGraphic",
    stdDeviation: 7
  })), /*#__PURE__*/React.createElement("rect", {
    id: "zs8p7024ra",
    width: 64,
    height: 64,
    x: 0,
    y: 0,
    rx: 32
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("mask", {
    id: "50ak4whhte",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#zs8p7024ra"
  })), /*#__PURE__*/React.createElement("use", {
    fill: "url(#846rmjzuab)",
    xlinkHref: "#zs8p7024ra"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 23.559,
    cy: 48.559,
    r: 23.5,
    fill: "url(#keli8zopic)",
    filter: "url(#ado0rxvh3d)",
    mask: "url(#50ak4whhte)",
    opacity: 0.8
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#FFF"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M8.864 0C3.977 0 0 3.977 0 8.864v12.272C0 26.023 3.977 30 8.864 30h12.272C26.023 30 30 26.023 30 21.136V8.864C30 3.977 26.023 0 21.136 0H8.864zm.061 1.5h12.15c4.108 0 7.425 3.317 7.425 7.425v12.15c0 4.108-3.317 7.425-7.425 7.425H8.925c-4.108 0-7.425-3.317-7.425-7.425V8.925C1.5 4.817 4.817 1.5 8.925 1.5zM23.25 6c-.414 0-.75.336-.75.75s.336.75.75.75.75-.336.75-.75-.336-.75-.75-.75zM15 7.5c-4.134 0-7.5 3.366-7.5 7.5s3.366 7.5 7.5 7.5 7.5-3.366 7.5-7.5-3.366-7.5-7.5-7.5zM15 9c3.322 0 6 2.678 6 6s-2.678 6-6 6-6-2.678-6-6 2.678-6 6-6z",
    transform: "translate(8 8) translate(9 9)"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIllustrationsFunnelTrafficInstagramAds);
export default __webpack_public_path__ + "static/media/illustrations-funnel-traffic-instagram-ads.093612dc.svg";
export { ForwardRef as ReactComponent };